const ANALYTICS_SESSION_KEY = "analytics_session_id";

export const getAnalyticsSessionId = (): string => {
  const existingSessionId = sessionStorage.getItem(ANALYTICS_SESSION_KEY);

  if (existingSessionId) {
    return existingSessionId;
  }

  const sessionId =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;

  sessionStorage.setItem(ANALYTICS_SESSION_KEY, sessionId);

  return sessionId;
};

// ---------------------------------------------------------
// Banner view deduplication
// ---------------------------------------------------------

const getBannerViewKey = (bannerId: number): string => {
  return `analytics_banner_view_${bannerId}`;
};

export const hasTrackedBannerView = (bannerId: number): boolean => {
  return sessionStorage.getItem(getBannerViewKey(bannerId)) === "true";
};

export const markBannerViewTracked = (bannerId: number): void => {
  sessionStorage.setItem(getBannerViewKey(bannerId), "true");
};
